import { render, staticRenderFns } from "./shpksq.vue?vue&type=template&id=6fd2662e&scoped=true&"
import script from "./shpksq.vue?vue&type=script&lang=js&"
export * from "./shpksq.vue?vue&type=script&lang=js&"
import style0 from "./shpksq.vue?vue&type=style&index=0&id=6fd2662e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2662e",
  null
  
)

export default component.exports